import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import SalesModal from '../../../components/sales/sales.component';
import ReactTooltip from "react-tooltip";

export default function DocumentSalesType({ onSelectReferenceSale, onSelectedTypeDocument, inputValue }) {

  const [typeSale, setTypeSale] = useState("VN");
  const [salesModal, setSalesModal] = useState(false);

  useEffect(() => {
    onSelectedTypeDocument(typeSale);
    onSelectReferenceSale(null);
  },[typeSale])

  const toggleSalesModal = () => {
    setSalesModal(!salesModal);
  }

  const optionAction = (event) => {
    setTypeSale(event.target.value);
  }

  const openSalesItems = () => {
    toggleSalesModal();
  }

  const onSelectItem = (item) => {
    toggleSalesModal();
    onSelectReferenceSale(item);
  }

  return (
    <>
        <div className="d-flex flex-row " onChange={optionAction}>
          <div className="d-flex flex-row mr-3 align-items-center">
            <input type="radio" value="VN" name="typeSale" defaultChecked={typeSale === 'VN'} /> 
            <div data-tip data-for="vn-information" className="ml-2">(VN) VENTA NORMAL</div>
          </div>
            {' '}
          <div className="d-flex flex-row  align-items-center mr-3">
            <input type="radio" value="ND" name="typeSale" defaultChecked={typeSale === 'ND'} /> 
            <div data-tip data-for="nd-information" className="ml-2">(ND) NOTA DE DÉBITO</div>
          </div>
        </div>
        {typeSale === 'ND' &&
            <div className="row mb-4 mt-4">
                <div className="col">
                    <h3>Nota de débito</h3>
                    <div>Para crear una nota de débito debe seleccionar a que recibo sera asociado.</div>
                    <div className="mt-2">
                        <small>Comprobante de venta asociado</small>
                        <div className="d-flex mb-2">
                                <input type="text"
                                    className={`form-control input-border`}
                                    disabled
                                    value={inputValue()}
                                />
                                <button type="button" onClick={openSalesItems} className="btnx btnx-warn icon-table">
                                    <FontAwesomeIcon icon={faSearch} />
                                </button>
                        </div>
                    </div>
                    <SalesModal
                        visible={salesModal}
                        onSelectItem={(item) => onSelectItem(item)}
                        close={() => toggleSalesModal()}
                        initialTypeDocument={'VN'}
                    />
                </div>
            </div>
        }
        <ReactTooltip id="vn-information" place="top" effect="solid">
          <b>Venta normal: genera una un recibo de pago.</b>
        </ReactTooltip>
        <ReactTooltip id="nd-information" place="top" effect="solid">
          <b>
            Nota de débito: genere un recibo de pago,<br/>
            que afecta a un recibo ya creado para<br/>
            modificar el monto pagado.
          </b>
        </ReactTooltip>
    </>
  )
}
